import React from 'react';
import Shell from './Shell';

export default class ShellContainer extends React.Component {
  render() {
    return <Shell />;
  }
}
